import { Button, Drawer, Tooltip, Upload } from 'antd';
import { useEffect, useState } from 'react';
import getFormatMessage from '../../../../../locales/get-format-message';
import Papa from 'papaparse';
import { emailRule } from '../../../../utils/password';
import DownloadIcon from '../../../../../assets/svg/download-csv-icon.svg';
import closeIcon from '../../../../../assets/svg/close-icon.svg';
import UploadIcon from '../../../../../assets/svg/cloud-upload.svg';
import DownloadCsv from '../../../../../assets/svg/download-jianxi-csv.svg';
import DelIcon from '../../../../../assets/svg/del-content-icon.svg';
import { VersionSelect } from './select-version';
import {
  IAPIStudioMemberHasPermissionItem,
  IAuditItem,
} from '../../../../../model/api-modules';
import { RoleGroupType } from '../../../../../model/rbac';
import UploadLoadingIcon from '../../../../../assets/images/upload-loading-icon.png';
import { ModalWrap } from '../../../../component/modal-wrap';
import warnImage from '../../../../../assets/images/warn-yellow.png';
import { SelectRoleGroupComponent } from './select-role-group';
import { IOption } from '../../organization-content';
import { inviteMember } from '../../../../../api';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../../../components/message';
import { downCSVTemplate } from './lib/csv';
import { auditWriteLog } from '../../../../lib/aduit-log';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  readonly studioId: string;
  readonly username?: string;
  readonly isJustRole: boolean;
  readonly memberList: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
  readonly roleGroupNames?: string[];
  // readonly rolesList: ReadonlyArray<IRBACRole>;
  // readonly userGroupsList: ReadonlyArray<IRBACUserGroup>;
  readonly rolesAndGroupsOptions: IOption[];
}

export const InviteMemberDrawer = (props: IProps) => {
  // const [emailInput, setEmailInput] = useState<string>('');
  const [emailTags, setEmailTags] = useState<string[]>([]);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [uploadedFileLoading, setUploadedFileLoading] =
    useState<boolean>(false);
  const [successEmails, setSuccessEmails] = useState<string[]>([]);
  const [failedEmails, setFailedEmails] = useState<string[]>([]);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [duplicateEmails, setDuplicateEmails] = useState<string[]>([]);
  const [showInvalidEmails, setShowInvalidEmails] = useState<boolean>(false);
  const [confirmDiscardModal, setConfirmDiscardModal] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isCanSubmit, setIsCanSubmit] = useState<boolean>(false);
  const [roleGroupList, setRoleGroupList] = useState<string[]>([]);
  const [authType, setAuthType] = useState<RoleGroupType>(RoleGroupType.Role);
  //   const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const handleRoleGroupChange = (
    selectedOptions: string[],
    authType: RoleGroupType.Role | RoleGroupType.Group
  ) => {
    console.log('邀请-selectedOptions,authType', selectedOptions, authType);
    setRoleGroupList(selectedOptions);
    setAuthType(authType);
  };

  const isValidEmail = (email: string) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email.trim());
  };
  const checkExistingUser = (email: string): boolean => {
    if (props.memberList.find((member) => member.UserID === email)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (emailTags.length > 0 && roleGroupList.length > 0) {
      let hasError = false;
      let hasExistingUser = false;

      for (const email of emailTags) {
        if (!isValidEmail(email)) {
          hasError = true;
          break;
        }
        if (checkExistingUser(email)) {
          hasExistingUser = true;
          break;
        }
      }
      console.log('!hasError && !hasExistingUser', hasError, hasExistingUser);
      setIsCanSubmit(!hasError && !hasExistingUser);
    } else {
      setIsCanSubmit(false);
    }
  }, [emailTags, roleGroupList]);
  const handleEmailInputChange = (e: string[]) => {
    console.log('email', e);
    setEmailTags(e);
  };

  const handleFileUpload = (file: File | null) => {
    setUploadedFile(file);
    setUploadedFileLoading(true);
    Papa.parse(file, {
      complete: (results: { data: any[] }) => {
        const validEmails: string[] = [];
        const invalidEmails: string[] = [];
        const duplicateEmails: string[] = [];
        const emailCounts: { [email: string]: number } = {};
        results.data.forEach((row) => {
          row.forEach((cell: any) => {
            const email = cell.toString().trim();
            // 格式验证
            emailRule({}, email, (error) => {
              if (error) {
                console.log('解析失败的邮箱:', email);
                invalidEmails.push(email);
              } else if (email.trim() !== '') {
                if (validEmails.includes(email)) {
                  if (emailCounts[email]) {
                    emailCounts[email] += 1;
                  } else {
                    emailCounts[email] = 2; // 第二次出现时设置为2
                  }
                } else {
                  validEmails.push(email);
                }
              }
            });
          });
        });

        setEmailTags((prevEmailTags) => {
          const uniqueEmailTags = new Set([...prevEmailTags, ...validEmails]);
          return Array.from(uniqueEmailTags);
        });
        setSuccessEmails((prevSuccessEmails) => {
          const uniqueSuccessEmails = new Set([
            ...prevSuccessEmails,
            ...validEmails,
          ]);
          return Array.from(uniqueSuccessEmails);
        });
        Object.keys(emailCounts).forEach((email) => {
          for (let i = 1; i < emailCounts[email]; i++) {
            duplicateEmails.push(email);
          }
        });
        setDuplicateEmails(duplicateEmails);
        // setDuplicateEmails(duplicateEmails);
        setFailedEmails((prevFailedEmails) => [
          ...prevFailedEmails,
          ...invalidEmails,
        ]);
        if (validEmails.length === 0 && invalidEmails.length > 0) {
          setUploadError(true);
        }
        setUploadedFileLoading(false);
      },
      error: (error: any) => {
        console.log('解析文件错误:', error);
        setUploadError(true);
        setUploadedFileLoading(false);
      },
    });
  };

  const handleOpenSubmit = async () => {
    setLoading(true);
    try {
      if (emailTags.length > 20) {
        messageWarning(getFormatMessage('max_limit_emails_tags_20'));
        return;
      }
      const roleGroupLists = roleGroupList.map((group) => {
        if (group.startsWith('roleGroup-')) {
          return parseInt(group.substring(10), 10);
        }
        if (group.startsWith('userGroup-')) {
          return parseInt(group.substring(10), 10);
        }
        return 0;
      });
      // console.log('提交新增方法,roleGroupLists', authType, roleGroupLists);
      // 设置用户为角色或者用户组
      const res = await inviteMember(
        props.studioId,
        emailTags,
        location.origin,
        authType,
        roleGroupLists
      );
      auditWriteLog(IAuditItem.InviteOrganizationMember, {
        detail: {
          studioID: props.studioId,
          uid: emailTags,
          url: location.origin,
          authType,
          authID: roleGroupLists,
        },
      });
      console.log('邀请的方法--res', res);
      if (res) {
        if (res.code === 0) {
          messageSuccess(getFormatMessage('invite_success'));
          confirmDiscardChanges();
        } else {
          messageError(getFormatMessage('invite_fail'));
        }
      }
    } catch (error: any) {
      console.log('邀请的方法error:', error?.apiError); // // 邀请成员，角色id找不到记录或者邀请了加入owner角色
      // if(error?.apiError.code === 101249){
      //   messageError(getFormatMessage('invite_fail'));
      // }
      messageError(getFormatMessage('invite_fail'));
      return false;
    } finally {
      setLoading(false);
    }
  };
  const handleFileRemove = () => {
    if (uploadedFileLoading) {
      return null;
    }
    setUploadedFile(null);
    // 仅删除上传传入的
    setEmailTags((prevEmailTags) => {
      const filteredEmailTags = prevEmailTags.filter(
        (email) => !successEmails.includes(email)
      );
      return filteredEmailTags;
    });
    setSuccessEmails([]);
    setFailedEmails([]);
    setUploadError(false);
  };
  const handleToggleInvalidEmails = () => {
    setShowInvalidEmails(!showInvalidEmails);
  };
  // 关闭抽屉二次确认
  const confirmDiscardChanges = async () => {
    setUploadedFile(null);
    setEmailTags([]);
    setSuccessEmails([]);
    setFailedEmails([]);
    setUploadError(false);
    setConfirmDiscardModal(false);
    setIsCanSubmit(false);
    props.onClose();
    return true;
  };
  const handleCloseEvent = () => {
    if (loading) {
      return false;
    }
    if (
      emailTags.length > 0 ||
      (roleGroupList[0] && !roleGroupList[0].includes('roleGroup'))
    ) {
      setConfirmDiscardModal(true);
    } else {
      props.onClose();
    }
  };

  const onDownTemplate = () => {
    downCSVTemplate('template', [['Emails@email.com']]);
  };
  const errLength = failedEmails.length + duplicateEmails.length;
  // 新div为挂载容器
  const tooltipContainer = document.createElement('div');
  tooltipContainer.classList.add('custom-tooltip-container');
  document.body.appendChild(tooltipContainer);
  return (
    <Drawer
      onClose={handleCloseEvent}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{getFormatMessage('invite_member')}</span>
          <img
            src={closeIcon}
            className="sync-close-icon"
            onClick={handleCloseEvent}
          />
        </div>
      }
      placement="right"
      width={720}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <button
            className="gc-btn sub-button"
            onClick={handleCloseEvent}
            disabled={loading}
          >
            {getFormatMessage('cancel')}
          </button>
          <Button
            className="gc-btn gc-btn-primary gc-btn-download"
            loading={loading}
            disabled={!isCanSubmit}
            onClick={handleOpenSubmit}
          >
            {getFormatMessage('invite')}
          </Button>
        </div>
      }
    >
      <div className="edit-member">
        <div>
          <div className="edit-title">
            {getFormatMessage('email_uppercase')}
            <span className="require-icon">*</span>
          </div>
          <div>
            <VersionSelect
              selectedValues={emailTags}
              onEmailChange={handleEmailInputChange}
              // memberList={props.memberList}
              isValidEmail={isValidEmail}
              checkExistingUser={checkExistingUser}
            />
          </div>
        </div>
        <div>
          {/* 上传有结果后隐藏 */}
          {!uploadedFile && (
            <div className="edit-title upload-title">
              <span className="upload-tips">
                {getFormatMessage('upload_tips_desc')}
              </span>
              <span
                className="download-template-content"
                onClick={onDownTemplate}
              >
                <img className="download-icon" src={DownloadIcon} />
                <span>{getFormatMessage('download_template')}</span>
              </span>
            </div>
          )}
          {/* 未上传 */}
          <div className="upload-init">
            {!uploadedFile && (
              <div>
                <Upload.Dragger
                  beforeUpload={(file) => {
                    handleFileUpload(file);
                    return false; // 阻止默认
                  }}
                >
                  <img src={UploadIcon} height={32} width={32} />
                  <div className="upload-tips">
                    {getFormatMessage('upload_click_desc')}
                    <span>{getFormatMessage('upload')}</span>
                  </div>
                </Upload.Dragger>
              </div>
            )}
          </div>
          {uploadedFile ? (
            <div
              className={`upload-result-content ${
                uploadError ? 'upload-result-error' : ''
              }`}
            >
              {/* 文件名和删除icon */}
              <div className="file-show">
                {' '}
                {uploadedFile && (
                  <>
                    <img src={DownloadCsv} height={16} width={16} />
                    <span color="#4E5969">{uploadedFile.name}</span>
                    <Tooltip
                      placement="topLeft"
                      title={getFormatMessage('del_clear_already_email_desc')}
                      getPopupContainer={() => tooltipContainer}
                      overlayClassName="edit-member-tooltip"
                    >
                      <img
                        className="del-upload-icon"
                        src={DelIcon}
                        onClick={handleFileRemove}
                      />
                    </Tooltip>
                  </>
                )}
              </div>
              {/* 上传中 */}
              {uploadedFile && uploadedFileLoading && (
                <div className="upload-loading">
                  <img
                    className="upload-loading-icon"
                    src={UploadLoadingIcon}
                  />
                  <span className="upload-result-title loading-content">
                    {getFormatMessage('now_parse_email_desc')}
                  </span>
                </div>
              )}

              {/* 已经上传 */}
              {uploadedFile && !uploadedFileLoading && (
                <div className="upload-done">
                  {/* 1.全部成功，2.部分成功 */}
                  <div className="upload-done-tips">
                    {successEmails.length > 0 && (
                      <span className="upload-result-title">
                        {getFormatMessage('success_email_length_desc', {
                          params: {
                            successLength: successEmails.length,
                          },
                        })}
                      </span>
                    )}
                    {(failedEmails.length | duplicateEmails.length) > 0 &&
                      !uploadError && (
                        <span className="upload-result-title">
                          ， <span className="error-desc-inline"></span>
                          {getFormatMessage('err_email_length_desc', {
                            params: {
                              errLength,
                            },
                          })}
                          <span
                            className="show-hide-span"
                            onClick={handleToggleInvalidEmails}
                          >
                            {showInvalidEmails
                              ? getFormatMessage('hide_invalid_email')
                              : getFormatMessage('show_invalid_email')}
                          </span>
                        </span>
                      )}
                    {/* 没有成功的 */}
                    <div className="upload-error-all">
                      {/* 3.上传成功，解析失败 */}
                      {successEmails.length === 0 &&
                        failedEmails.length > 0 &&
                        uploadError && (
                          <span>{getFormatMessage('file_parse_err_desc')}</span>
                        )}
                      {/* 4.上传失败 */}
                      {successEmails.length === 0 &&
                        failedEmails.length === 0 &&
                        uploadError && (
                          <span>
                            {getFormatMessage('internet_error_file_err_desc')}
                          </span>
                        )}
                    </div>
                  </div>
                  {showInvalidEmails ? (
                    <div className="upload-error-content">
                      {failedEmails.length > 0 && (
                        <div className="error-desc">
                          <span className="error-line">
                            <span className="dot"></span>
                            {getFormatMessage('email_valid_parse_desc')}
                          </span>
                          <span>{failedEmails.join('; ')}</span>
                        </div>
                      )}
                      {duplicateEmails.length > 0 && (
                        <div className="error-desc">
                          <span className="error-line">
                            <span className="dot"></span>
                            {getFormatMessage('email_duplicate_parse_desc')}
                          </span>
                          <span>{duplicateEmails.join('; ')}</span>
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          ) : null}
          {uploadedFile && (
            <div
              className="download-template-content upload-template-bottom"
              onClick={onDownTemplate}
            >
              <img className="download-icon" src={DownloadIcon} />
              <span>{getFormatMessage('download_template')}</span>
            </div>
          )}
          {/* role/Group下拉框 */}
          <div style={{ marginTop: 28 }}>
            <SelectRoleGroupComponent
              isJustRole={props.isJustRole}
              rolesAndGroupsOptions={props.rolesAndGroupsOptions}
              setRoleGroupList={handleRoleGroupChange}
            />
          </div>
        </div>

        {confirmDiscardModal && (
          <ModalWrap
            width="440px"
            // loading={loading}
            onOk={confirmDiscardChanges}
            cancelText={getFormatMessage('cancel')}
            onClose={() => {
              setConfirmDiscardModal(false);
            }}
            oKText={getFormatMessage('Confirm')}
            title={
              <p className="fail-title">
                <img
                  src={warnImage}
                  alt="Warning"
                  style={{ marginRight: '10px', marginTop: '-2px' }}
                />
                <span>{getFormatMessage('discard_changes')}</span>
              </p>
            }
            className="delete-env-modal delete-modal"
          >
            <div style={{ whiteSpace: 'pre-line' }}>
              {getFormatMessage('sure_discard_changes')}
            </div>
          </ModalWrap>
        )}
      </div>
    </Drawer>
  );
};
